import React from 'react';
import { SvgIcon } from '@mui/material';

export function AlfaLogo(props) {
  return (
    <SvgIcon
      sx={{ width: '200px', height: '64px', viewBox: '0 0 200px 64px' }}
      {...props}
      viewBox="0 0 200 64"
      fill="none"
    >
      <svg
        width="200"
        height="64"
        viewBox="0 0 200 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M101.037 6.02246C104.635 6.02246 105.776 8.55338 106.653 11.0843C107.092 12.2189 116.394 37.5281 116.657 38.3135C116.745 38.4881 116.657 38.8372 116.394 39.0117C116.043 39.099 111.216 41.019 110.953 41.1063C110.69 41.1935 110.427 41.019 110.251 40.7572C110.163 40.4953 108.145 34.9971 107.882 34.3862H94.193C94.0175 34.9971 91.9115 40.4953 91.8237 40.7572C91.736 41.019 91.4727 41.1935 91.1217 41.1063C90.8585 41.019 86.0322 39.099 85.6812 39.0117C85.418 38.9244 85.2425 38.5753 85.3302 38.3135C85.769 37.3535 94.9827 12.3934 95.4215 11.0843C96.299 8.64065 97.4397 6.02246 101.037 6.02246ZM84.716 51.3172C84.4527 51.3172 84.1895 51.579 84.1895 51.8408V57.7754C84.1895 58.0372 84.4527 58.2991 84.716 58.2991H117.447C117.71 58.2991 117.973 58.0372 117.973 57.7754V51.8408C117.973 51.579 117.71 51.3172 117.447 51.3172H84.716ZM101.037 14.3134L96.3867 28.1898H105.776L101.037 14.3134C101.125 14.3134 101.037 14.3134 101.037 14.3134Z"
          fill="#ED1D1D"
        />
      </svg>
    </SvgIcon>
  );
}
